import { useAttachments } from './attachments-provider';
import { InputAttachmentsPreview } from '../../../ui/input-attachments-preview';

/**
 * Component that displays the preview of uploaded attachments.
 */
export function ChatAttachmentsPreview() {
  const { attachments, setAttachments } = useAttachments();

  return <InputAttachmentsPreview attachments={attachments} setAttachments={setAttachments} />;
}
